import { Box, Typography } from "@mui/material"
import { Payload } from "routes/schedule/controller/payload"
import { ScheduleIntroductionContentAfter } from "slot-definitions"
import { ScheduleIntroductionContentWrapper } from "routes/schedule/scheduleIntroduction"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ContentOverrideField } from "routes/regime/components/content-override-field"
import { IntroSubjectJustification } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/intro-subject-justification"

// Replaces the whole schedule-introduction editing area for collaboration clients: the master intro
// body and note become directly editable inline (writing to the payload overrides), in place of the
// read-only display and the prepend "Add Introduction / Add Notes" buttons. We keep the
// ScheduleIntroductionContentWrapper.Wrapper and the ScheduleIntroductionContentAfter slot so other
// features that hang off the intro — notably the share-link comment scroll/highlight target plugged
// into that wrapper — keep working.
export function InlineIntroOverride() {
    const { schedule } = useBoundContext()
    return (
        <ScheduleIntroductionContentWrapper.Wrapper schedule={schedule}>
            <Payload>
                <Box mt={2} mb={3}>
                    <Box data-cy="schedule-intro-content" sx={{ position: "relative" }}>
                        <ContentOverrideField
                            field="introContentOverride"
                            sourcePath="intro.content"
                            label="Introduction"
                        />
                        <IntroSubjectJustification
                            subjectId="intro"
                            subjectTitle="Introduction"
                            part="content"
                            field="introContentOverride"
                        />
                    </Box>
                    <ScheduleIntroductionContentAfter.Slot />
                    <Box
                        data-cy="schedule-intro-note"
                        sx={{ mt: 2, paddingInlineStart: 2, fontSize: 14, position: "relative" }}
                    >
                        <Typography variant="overline">Notes</Typography>
                        <ContentOverrideField
                            field="introNoteOverride"
                            sourcePath="intro.note"
                            label="Introduction notes"
                        />
                        <IntroSubjectJustification
                            subjectId="introNote"
                            subjectTitle="Introduction Notes"
                            part="note"
                            field="introNoteOverride"
                        />
                    </Box>
                </Box>
            </Payload>
        </ScheduleIntroductionContentWrapper.Wrapper>
    )
}
